import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcTags from '@/views/Automation/CampaignCreatorV2/components/CcTags/CcTags.ts.vue';
import CcVariableTags from '@/views/Automation/CampaignCreatorV2/components/CcVariableTags/CcVariableTags.ts.vue';
import { countries, languages } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/countries';
import { country_group } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/country_group';
import { TargetingAbVariables } from '@/views/Automation/CampaignCreatorV2/store/AbVariables';
import useAdAccountStore from '@/views/Automation/CampaignCreatorV2/store/AdAccount';
import useCampaignStore from '@/views/Automation/CampaignCreatorV2/store/Campaign';
import useTargetingStore from '@/views/Automation/CampaignCreatorV2/store/Targeting';
import { InternalABVariable, SupportedEntities } from '@/views/Automation/CampaignCreatorV2/store/Types';
import { CardLayer, GeoTargeting, SupportedLocationTypes } from '@/views/Automation/CampaignCreatorV2/types';
import { AdSetAbGroups } from '@/views/Automation/CampaignCreatorV2/validation/AdSet';
import treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { api } from '@sh/services/api';
import { debounce } from 'lodash';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, ref } from 'vue';
import VueSlider from 'vue-slider-component';


export default /*#__PURE__*/_defineComponent({
  __name: 'AudienceControls.ts',
  setup(__props) {

const adAccountStore = useAdAccountStore();
const adAccountGetters = storeToRefs(adAccountStore);
const targetingStore = useTargetingStore();
const targetingGetters = storeToRefs(targetingStore);
const { getField } = targetingGetters;
const campaignGetters = storeToRefs(useCampaignStore());
const locationOptions = ref<any>([]);

onBeforeMount(() => {
  const mapped = country_group.map((cg) => {
    const group = {
      ...cg,
      id: cg.key,
      label: cg.name,
      type: cg.type,
      children: cg.country_codes.map((c) => {
        const country = countries.find((cc) => cc.country_code === c);
        return {
          ...country,
          id: `${cg.key}-${country?.key}`,
          label: country?.name,
        };
      }),
    };
    return group;
  });
  locationOptions.value = mapped;
});

const genderOptions = [
  { text: 'Male', value: '1' },
  { text: 'Female', value: '2' },
  { text: 'All', value: '0' },
];

const languageOptions = computed(() => {
  return languages.map((l) => ({
    id: l.key,
    label: l.name,
  }));
});

const locales = computed(() => targetingGetters.getField.value('locales').value?.[0] || {});
const updateLocales = (value: string[]) => {
  console.log('value', value);
  targetingStore.addOrEditVariable('locales', {
    field: 'locales',
    value,
    variableId: locales.value?.variableId || 'locales',
  });
};
const locations = computed(() => {
  const currentValue = (targetingGetters.getField.value('geo_locations')?.value || [])?.[0] || {};
  const locationValue = Object.values(currentValue?.value)
    ?.flat()
    ?.map((r) => ({
      ...r,
      id: r.key,
      type: r.type,
      label: `${r.name}, ${r.type}`,
    }));
  return {
    ...currentValue,
    value: locationValue,
  };
});

const isSpecialCategoryCampaign = computed(() => {
  return campaignGetters.isCampaignForSpecialCategories;
});

const gender = computed(() => targetingGetters.getField.value('genders').value?.[0]);

const age = computed(() => {
  const ageMax = targetingGetters.getField.value('age_max').value?.[0]?.value || 18;
  const ageMin = targetingGetters.getField.value('age_min').value?.[0]?.value || 65;

  return [ageMin, ageMax];
});

const excludeLocations = computed(() => {
  const currentValue = (targetingGetters.getField.value('excluded_geo_locations')?.value || [])[0] || {};
  const locationValue = Object.values(currentValue?.value)
    ?.flat()
    ?.map((r) => ({
      ...r,
      id: r.key,
      type: r.type,
      label: `${r.name}, ${r.type}`,
    }));
  return {
    ...currentValue,
    value: locationValue,
  };
});

function updateGender(value: string) {
  // TODO: Facebook handles case when all genders are selected, by removing this field
  targetingStore.addOrEditVariable('genders', {
    field: 'genders',
    value: [+value],
    variableId: 'genders',
  });
}

function updateLocationVariable(
  currentLocations: Array<GeoTargeting & { children?: GeoTargeting[] }> = [],
  field: 'geo_locations' | 'excluded_geo_locations'
) {
  const variable = (targetingGetters.getField.value(field)?.value || [])?.[0] || {};

  const reduceByType = currentLocations.reduce<Partial<Record<SupportedLocationTypes, Record<string, GeoTargeting>>>>(
    (acc, { children, ...curr }) => {
      if (!acc[curr.type]) {
        acc[curr.type] = {};
      }
      (acc as any)[curr.type][curr.key] = curr;
      return acc;
    },
    {}
  );
  targetingStore.addOrEditVariable(field, {
    field,
    value: {
      country_group: Object.values(reduceByType.country_group || {}),
      cities: Object.values(reduceByType.city || {}),
      regions: Object.values(reduceByType.region || {}),
      countries: Object.values(reduceByType.country || {}),
      zips: Object.values(reduceByType.zip || {}),
    },
    variableId: variable.variableId,
    abGroup: variable.abGroup,
  });
}

function removeAllLocations(locationType: 'geo_locations' | 'excluded_geo_locations') {
  updateLocationVariable([], locationType);
}

function addManualLocation(locations: string) {
  console.log(locations, 'locations', 'variableId');
}

function handleTagsActions(action: string | undefined, locationType: 'geo_locations' | 'excluded_geo_locations') {
  if (action === 'clear') removeAllLocations(locationType);
}

function removeLocation(id: string) {
  const currentLocations = (locations?.value?.value as GeoTargeting[])?.filter((r) => r.key !== id);
  updateLocationVariable(currentLocations, 'geo_locations');
}

function removeExcludeLocation(id: string) {
  const currentLocations = (excludeLocations.value?.value as GeoTargeting[])?.filter((r) => r.key !== id);
  updateLocationVariable(currentLocations, 'excluded_geo_locations');
}

function updateLocation(targetings: GeoTargeting[]) {
  const currentLocations = (locations?.value?.value as GeoTargeting[])?.concat(targetings);
  updateLocationVariable(currentLocations, 'geo_locations');
}

function updateExcludeLocation(targetings: GeoTargeting[]) {
  const currentLocations = (excludeLocations?.value?.value as GeoTargeting[])?.concat(targetings);
  updateLocationVariable(currentLocations, 'excluded_geo_locations');
}

const ageName = computed(() => {
  const fullname = targetingGetters.getField.value('age_max').value?.[0]?.name || 'Age Variant';
  return fullname.replace('age_max', '').trim();
});

function renameVariable(variable: InternalABVariable<any> & { field: keyof TargetingAbVariables }, newName: string) {
  targetingStore.addOrEditVariableName(variable.field, variable.abGroup!, variable.variableId, newName);
}

function renameAge(newName: string) {
  renameVariable({ ...targetingGetters.getField.value('age_max').value?.[0]!, field: 'age_max' }, newName);
  renameVariable({ ...targetingGetters.getField.value('age_min').value?.[0]!, field: 'age_min' }, newName);
}

const updateAge = debounce((value: number[]) => {
  const sortAge = value.sort((a, b) => a - b);
  targetingStore.addOrEditVariable('age_max', {
    field: 'age_max',
    value: sortAge[1],
    variableId: 'age_max',
  });
  targetingStore.addOrEditVariable('age_min', {
    field: 'age_min',
    value: sortAge[0],
    variableId: 'age_min',
  });
}, 500);

function getCategories() {
  const explicit = isSpecialCategoryCampaign.value?.value;
  const list = [
    explicit ? undefined : SupportedLocationTypes.city,
    explicit ? undefined : SupportedLocationTypes.region,
    SupportedLocationTypes.country,
    SupportedLocationTypes.country_group,
  ].filter(Boolean) as SupportedLocationTypes[];
  return list;
}

function loadOptions({ action, searchQuery, callback }: any) {
  if (action === ASYNC_SEARCH) {
    const { accessToken, adAccountId } = adAccountGetters.currentAdAccount.value?.credentials || {
      accessToken: '',
      adAccountId: '',
    };
    api.facebook.getTargetLocation(accessToken, adAccountId, searchQuery, getCategories()).then((res) => {
      const mapped = res.data.map((r) => ({
        ...r,
        id: r.key,
        type: r.type,
        label: `${r.name}, ${r.type}`,
      }));
      callback(null, mapped);
    });
  }
}

function onNewGroupAdd() {
  targetingStore.addOrEditVariable('geo_locations', {
    field: 'geo_locations',
    value: {
      country_group: [],
      cities: [],
      regions: [],
      countries: [],
      zips: [],
    },
    variableId: 'geo_locations',
    name: 'Location Variant',
  });

  targetingStore.addOrEditVariable('excluded_geo_locations', {
    field: 'excluded_geo_locations',
    value: {
      country_group: [],
      cities: [],
      regions: [],
      countries: [],
      zips: [],
    },
    variableId: 'excluded_geo_locations',
    name: 'Location Variant',
  });

  targetingStore.addOrEditVariable('genders', {
    field: 'genders',
    value: [0],
    variableId: 'genders',
  });
}

return { __sfc: true,adAccountStore, adAccountGetters, targetingStore, targetingGetters, getField, campaignGetters, locationOptions, genderOptions, languageOptions, locales, updateLocales, locations, isSpecialCategoryCampaign, gender, age, excludeLocations, updateGender, updateLocationVariable, removeAllLocations, addManualLocation, handleTagsActions, removeLocation, removeExcludeLocation, updateLocation, updateExcludeLocation, ageName, renameVariable, renameAge, updateAge, getCategories, loadOptions, onNewGroupAdd, CcCard, CcCardItem, CcError, CcIcon, CcTags, CcVariableTags, SupportedEntities, CardLayer, AdSetAbGroups, treeselect, VueSlider }
}

})